import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const dims = {
  img: { width: 250, height: 250 },
};

export const useStyles = makeStyles((theme) => ({
  '@global': {
    '& .popContainer': {
      padding: theme.spacing(1),

      '& .spaceVert': {
        margin: `${theme.spacing(3)} 0`
      }
    }
  },
  buttonRow: {
    flexDirection: 'row',
    display: 'flex',
    margin: `${theme.spacing(3)} 0`,
    alignItems: 'space-between',
  },
  button: {
    marginRight: theme.spacing(2),
  },

  row: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

  selectedRow: {
    position: 'absolute',
    left: 0,
    right: 0,

    backgroundColor: theme.colors.redLight,
    alignItems: 'center',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

    '& button': {
      minWidth: 'auto',
      marginRight: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),

      '& .MuiIcon-root': {
        fontSize: 15,
      },
      '& svg': {
        color: colors.white,
      },
    },
  },
  selectRowFixed: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
  },
  selButtonRow: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  selButton: {},
  selDelete: {
    backgroundColor: colors.danger,
    color: colors.white,
  },
  vr: {
    height: 33,
    width: 1,
    margin: `0 ${theme.spacing(1)} 0 ${theme.spacing(0.5)}`,
    backgroundColor: colors.black,
  },
  searchContainer: {
    margin: `${theme.spacing(3)} -7px`,
  },
  gridList: {
    justifyContent: 'left',
    '& .MuiImageListItem-root': {
      cursor: 'pointer',
    },
  },
  titleBar: {
    height: theme.spacing(6),
    background: `linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)`,
  },
  gridTile: {
    position: 'relative',

    '&.MuiImageListItem-root': {
      borderRadius: 4,
      overflow: 'hidden',

      '&::before': {
        pointerEvents: 'none',
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: 10,
        height: '0%',
        width: '100%',
        top: '0',
        transition: 'height 0.25s ease-out',
        background: `linear-gradient(to top, transparent 0%, #000000aa 100%)`,
      },
      '&:hover:before': {
        height: '40%',
      },
    },
    '&:hover': {
      '& button': {
        opacity: 1,
      },
      '& div #photoText': {
        backgroundColor: 'rgba(0,0,0,0.4)',
      },
    },
  },
  gridTileSelected: {
    backgroundColor: `${theme.palette.secondary.main}33`,
    '& .smallMediaContainer': {
      margin: theme.spacing(1.5),
      width: `calc(100% - ${theme.spacing(3)}) !important`,
      height: `calc(100% - ${theme.spacing(3)}) !important`,
    },
  },
  gridListFolder: {
    maxWidth: 'max(25%, 216px)',
    position: 'relative',
    '& .MuiImageListItemBar-root': {
      display: 'flex',
      height: theme.spacing(8),
    },
  },
  divider: {
    clear: 'both',
  },
  hrDivider: {
    clear: 'both',
    width: '100% !important',
    height: '31px !important',
    borderBottom: `4px solid ${theme.palette.action.disabled}`,
    fontSize: 14,
    boxSizing: 'border-box',
    cursor: 'default !important'
  },
  popOver: {},
  icon: {
    color: 'white',
  },
  imgContainer: {
    backgroundColor: 'transparent',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    color: colors.grey,

    '& .mui-image-wrapper img': {
      width: '100% !important',
      height: '100% !important'
    }    
  },
  img: {
    ...dims.img,
  },
  foldersRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    margin: `${theme.spacing(2)} 0`,
    alignItems: 'center',
  },
  chosenFolder: {},
  cfTitle: {
    paddingRight: 50,
    textAlign: 'left',
    margin: 0,
    marginBottom: 5,
  },
  cfSize: {
    textAlign: 'left',
    margin: 0,
    fontSize: 10,
  },
  closeFolder: {
    position: 'absolute',
    right: 0,
    top: 0,
    color: colors.white,
  },
  filterRow: {
    display: 'flex',
    flexDirection: 'row',
    maxHeight: 30,
    marginLeft: theme.spacing(1),

    '& .MuiInputBase-root': {
      marginRight: theme.spacing(2),
    },

    '& button': {
      minWidth: 'auto',
      marginRight: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),

      '& .MuiIcon-root': {
        fontSize: 15,
      },
    },
  },
  pos: {
    color: colors.buttonSuccess,
  },
  neg: {
    color: colors.redIcon,
  },
  iconRoot: {
    '&:hover': {
      backgroundColor: 'rgb(255,255,255,0.08)',
    },
  },
  checkIcon: {
    position: 'absolute',
    top: 4,
    left: 4,
    zIndex: 20,
    opacity: 0.4,
    color: 'white',
  },
  checkIconSelectMode: {
    opacity: 1,
  },
  checkIconSelected: {
    
  },
  photoText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    height: 40,
    backgroundColor: 'rgba(0,0,0,0.3)',
    width: '100%',

    '& .icon': {
      width: 40,
      color: colors.white,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',

      '& .MuiIcon-root': {
        fontSize: 15,
      },

      '& .pos': {
        color: colors.buttonSuccess,
      },
      '& .neg': {
        color: colors.redIcon,
      },
    },
    '& .textContainer': {
      color: colors.white,
      width: 'calc(100% - 40px)',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',

      '& .title': {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        position: 'relative',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '95%',
      },

      '& .subtitle': {
        fontSize: 12,
        display: 'inline-block',
        textOverflow: 'ellipsis',
        position: 'relative',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '95%',
      },
    },
  },
  photoTextSelected: {
    bottom: theme.spacing(1.5),
    width: `calc(100% - ${theme.spacing(3)})`,
    left: theme.spacing(1.5),
  },
  toolBtn: {
    position: 'absolute',
    left: 0,
    top: 0,

    '& svg': {
      color: colors.white,
    },
  },
  tool0: {},
  tool1: {
    left: BUFF * 1,
  },
  tool2: {
    left: BUFF * 2,
  },
  tool3: {
    left: BUFF * 3,
  },
}));

const BUFF = 64;
